import { createSlice } from "@reduxjs/toolkit";

const user = JSON.parse(localStorage.getItem("user"))

const initialState = {
    user: user? user : null,
    isAuthenticated:false,
}


const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers:{
        login: (state, action)=>{
            
            localStorage.setItem("user",JSON.stringify( action.payload))
            state.isAuthenticated = true
        },
        logout:(state)=>{
            localStorage.removeItem("user")
            state.user = null
            state.isAuthenticated = false
        }
    }
})



export const {login, logout}  = loginSlice.actions

export default loginSlice.reducer